import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/tailwind.css'
import './assets/styles/index.scss'
// import 'swiper/swiper-bundle.css';

import vueCountryRegionSelect from 'vue3-country-region-select'
import Notifications from '@kyvg/vue3-notification'


const app = createApp(App)

app.use(store)
app.use(router)
app.use(vueCountryRegionSelect)
app.use(Notifications)
app.mount('#app')
